import FetchRequest from "@/api/FetchRequest";
class depotApi {
    // 基础url
    static url = "/ai/voice/role";
    // 查询已发布
    static getList(pageNum: number, pageSize: number,publishStatus:number): Promise<any> {
        return FetchRequest.get(this.url + '/list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize+ '&publishStatus=' + publishStatus ,true );
    }
    // 查询已发布变声
    static getListChange(pageNum: number, pageSize: number,publishStatus:number,voiceChangeEnable:number): Promise<any> {
        return FetchRequest.get(this.url + '/list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize+ '&publishStatus=' + publishStatus + '&voiceChangeEnable=' + voiceChangeEnable,true );
    }
    // 查询已发布变声已完成
    static getListFinishChange(pageNum: number, pageSize: number,publishStatus:number,voiceChangeEnable:number,trainingStatus:number): Promise<any> {
        return FetchRequest.get(this.url + '/list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize+ '&publishStatus=' + publishStatus + '&voiceChangeEnable=' + voiceChangeEnable+ '&trainingStatus=' + trainingStatus,true );
    }
    // 
     // 查询已完成已发布
     static getFinishList(pageNum: number, pageSize: number,trainingStatus:number,publishStatus:number): Promise<any> {
        return FetchRequest.get(this.url + '/list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize+ '&trainingStatus=' + trainingStatus + '&publishStatus=' + publishStatus,true );
    }
     // 查询是否我的角色
     static getisMyList(pageNum: number, pageSize: number,isMine:boolean): Promise<any> {
        return FetchRequest.get(this.url + '/list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize+ '&isMine=' + isMine  ,true );
    }
    // 查询是否我的角色已完成
    static getisMyFinish(pageNum: number, pageSize: number,isMine:boolean,trainingStatus:number): Promise<any> {
        return FetchRequest.get(this.url + '/list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize+ '&isMine=' + isMine + '&trainingStatus=' + trainingStatus,true );
    }
    // 查询是否我的角色已完成变声
    static getisMyFinishChange(pageNum: number, pageSize: number,isMine:boolean,trainingStatus:number,voiceChangeEnable:number): Promise<any> {
        return FetchRequest.get(this.url + '/list'+'?pageNum=' + pageNum + '&pageSize=' + pageSize+ '&isMine=' + isMine + '&trainingStatus=' + trainingStatus+ '&voiceChangeEnable=' + voiceChangeEnable,true );
    }
    // 新增音色库
    static addDepot(name:string,avatar:string,demoText:string,intro:string, param:any,voiceChangeEnable:number,voiceFiles:any): Promise<any> {
        const data={
            name:name,
            avatar:avatar,
            demoText:demoText,
            intro:intro,
            param:param,
            voiceChangeEnable:voiceChangeEnable,
            voiceFiles:voiceFiles
        }
        return FetchRequest.post(this.url ,JSON.stringify(data) , true);
    }
    // 修改
    static putDepot(name:string,avatar:string,epoch:number,samplingRate:number,tone:number,voiceFiles:string): Promise<any> {
        const data={
            name:name,
            avatar:avatar,
            param:{
                epoch:epoch,
                samplingRate:samplingRate,
                tone:tone
            },
            voiceFiles:voiceFiles
        }
        return FetchRequest.put(this.url 	,JSON.stringify(data) , true);
    }
    // 取消发布 
    static putCancelRelease(roleId:string): Promise<any> {
        return FetchRequest.put(this.url +'/cancel/publish/'+ roleId	,'' , true);
    }
     // 发布 
     static putRelease(roleId:string): Promise<any> {
        return FetchRequest.put(this.url +'/publish/'+ roleId	,'' , true);
    }
    // 删除
    static delFolder(roleId: string): Promise<any> {
       
        return FetchRequest.del(this.url+'/'+roleId,'' , true);
    }
    // 试听克隆音色
    static tryListening(audioUrl: string,text: string): Promise<any> {
       
        return FetchRequest.post(this.url+'/tryListening'+'?audioUrl='+audioUrl +"&text="+text,'' , true);
    }
    // 
    static roleListening(roleId: string): Promise<any> {
       
        return FetchRequest.get(this.url+'/tryListening/role/'+roleId, true);
    }
}
export default depotApi;